import React, { useState, useMemo } from 'react';


export default function DigitalBooksListContainer({ data = [] }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('ALL');

  // Obtener categorías únicas de forma dinámica
  const categories = useMemo(() => {
    const cats = data.map((item) => item.Materia || 'Sin categoría');
    return ['ALL', ...Array.from(new Set(cats))];
  }, [data]);

  // Filtrar los datos en tiempo real por búsqueda y categoría
  const filteredData = useMemo(() => {
    return data.filter((item) => {
      const name = item.Nombre || '';
      const matchesSearch = name.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCategory =
        selectedCategory === 'ALL' || (item.Materia || 'Sin categoría') === selectedCategory;

      return matchesSearch && matchesCategory;
    });
  }, [data, searchTerm, selectedCategory]);

  // Función para manejar la descarga
  const handleDownload = (item) => {
    
    
  };

  return (
    <div className="px-3">
      {/* Encabezado y Filtros */}
      <div className="d-flex gap-3 mb-3">
        
        {/* Buscador por Nombre */}
        <div className="creamBackground rounded-4 p-3 regularText w-50">
          <div className="fs-3">
           Buscar
          </div>
          <input
            type="text"
            placeholder="Buscar por nombre..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-control form-control-lg"
          />
        </div>

        {/* Filtro por Categoría */}
        <div className="creamBackground rounded-4 p-3 regularText w-50">
          <div className="fs-3">
            Filtrar por categorías
          </div>
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            className="form-select"
          >
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat === 'ALL' ? 'Todas las Categorías' : cat}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Tabla de Objetos */}
      <div className="overflow-x-auto rounded-lg ">
        <table className="w-full table table-hover">
          <thead>
            <tr className="bg-gray-50 text-gray-600 text-xs font-semibold uppercase tracking-wider border-b border-gray-200">
              <th className="px-6 py-3">Nombre / Título</th>
              <th className="px-6 py-3">Categoría</th>
              <th className="px-6 py-3 text-center">Acción</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 text-sm text-gray-700">
            {filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <tr key={item.id || index} className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4 font-medium text-gray-900">
                    {item.Nombre || 'Sin título'}
                  </td>
                  <td className="px-6 py-4">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      {item.Materia || 'General'}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <button className="brownBtn">
                    <a
                        href={item.Link}
                        target="_blank"
                      className="text-white text-decoration-none"
                    >
                      
                      Descargar / Ver
                    </a>
                    </button>
                    
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="px-6 py-8 text-center text-gray-400">
                  No se encontraron resultados para los filtros seleccionados.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Contador de resultados */}
      <div className="mt-4 text-xs text-gray-500 text-right">
        Mostrando {filteredData.length} de {data.length} elementos
      </div>
    </div>
  );
}